<footer class="site__footer">
  <div class="container">
    <ul class="nav flex-column">
      <app-nav-item>
        <a class="nav-link" routerLink="/client/about-us">{{ "footer_menu.link_about_mrr" | translate }}</a>
      </app-nav-item>

      <app-nav-item>
        <a class="nav-link" routerLink="/client/contact">{{ "footer_menu.link_contact_mrr" | translate }}</a>
      </app-nav-item>

      <app-nav-item [class]="['language']">
        <div class="d-flex align-items-center">
          <a class="nav-link" (click)="switchLang('zh')" style="cursor: pointer;">{{ "footer_menu.link_lang_zh" | translate }}</a>
          <span class="nav-text mx-4">|</span>
          <a class="nav-link" (click)="switchLang('en')" style="cursor: pointer;">{{ "footer_menu.link_lang_en" | translate }}</a>
        </div>
      </app-nav-item>

      <app-nav-item>
        <a class="nav-link" routerLink="/client/term-and-conditions">{{ "footer_menu.link_terms_and_conditions" | translate }}</a>
      </app-nav-item>

      <app-nav-item>
        <a class="nav-link" routerLink="/client/privacy-policy">{{ "footer_menu.link_privacy_policy" | translate }}</a>
      </app-nav-item>

      <app-nav-item [class]="['copyright']">
        <div class="nav-text">
          <p class="mb-0">{{ "footer_menu.txt_copyright_line_1" | translate }}</p>
          <p class="mb-0">{{ "footer_menu.txt_copyright_line_2" | translate }}</p>
        </div>
      </app-nav-item>
    </ul>
  </div>
</footer>
